import { useEffect, useState, useCallback } from 'react';
import { CalendarBlank, Info } from '@phosphor-icons/react';
import { useT } from '@/i18n/LanguageContext';
import { mfgApi, WO_STATUSES } from './mfgApi';
import ProductionGantt, { STATUS_COLOR } from './ProductionGantt';
import WorkOrderDetailDialog from './WorkOrderDetailDialog';
import WorkOrderFormDialog from './WorkOrderFormDialog';

export default function ProductionSchedule() {
  const { t } = useT();
  const [data, setData] = useState({ work_centers: [], work_orders: [] });
  const [detailId, setDetailId] = useState(null);
  const [editWo, setEditWo] = useState(null);

  const load = useCallback(() => { mfgApi.productionSchedule().then(setData).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5 page-enter" data-testid="mfg-production-schedule">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <CalendarBlank size={22} weight="duotone" className="text-orange-500" />
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-zinc-900">{t('mfg.sched.title')}</h1>
            <p className="text-sm text-zinc-500 mt-0.5">{t('mfg.sched.desc')}</p>
          </div>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          {WO_STATUSES.filter((s) => s !== 'cancelled').map((s) => (
            <span key={s} className="inline-flex items-center gap-1.5 text-xs text-zinc-500" data-testid={`sched-legend-${s}`}>
              <span className="w-3 h-3 rounded-sm" style={{ backgroundColor: STATUS_COLOR[s] }} /> {t(`mfg.wo.status.${s}`)}
            </span>
          ))}
        </div>
      </div>

      {data.work_centers.length === 0 && (
        <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="sched-no-workcenters">
          <Info size={18} weight="duotone" className="shrink-0 mt-0.5" />
          <span>{t('mfg.sched.noWorkCenters')}</span>
        </div>
      )}

      <ProductionGantt
        lanes={data.work_centers}
        orders={data.work_orders}
        onOrderClick={(o) => setDetailId(o.id)}
      />

      <WorkOrderDetailDialog workOrderId={detailId} onClose={() => setDetailId(null)} onChanged={load}
        onEdit={(w) => { setDetailId(null); setEditWo(w); }} />
      <WorkOrderFormDialog open={!!editWo} workOrder={editWo}
        onClose={() => setEditWo(null)}
        onSaved={() => { setEditWo(null); load(); }} />
    </div>
  );
}
